export enum AuthStep {
  Login,
  Signup,
  Forgot,
  Unset,
}
